import store from "@/store"
import Qs from 'qs'

const axios = require('axios');

function getHeaders() {
    let headers = {"Content-type": "application/json"};
    if (store.state.auth.jwt) {
        headers["Authorization"] = 'Bearer ' + store.state.auth.jwt;
    }
    return headers;
}

const BASE_URL = process.env.VUE_APP_SSO_API_BASE_URL;
const MEMBERS_BASE_URL = process.env.VUE_APP_MEMBERS_API_BASE_URL;
const TRAINING_BASE_URL = process.env.VUE_APP_TRAINING_API_BASE_URL;
const EXCURSIONS_BASE_URL = process.env.VUE_APP_EXCURSIONS_API_BASE_URL;
const ACHIEVEMENT_BASE_URL = process.env.VUE_APP_ACHIEVEMENT_API_BASE_URL;

class EsepService {

    getUserInfo(username=null) {
        // username = username?? store.state.auth.username;
        if (null == username) username = store.state.auth.username;
        let url = "/user/" + username;

        return axios.get(BASE_URL + url, { headers: getHeaders() });
    }

    getUsersByCriteria(searchString) {
        let url = "/user";
        // console.log(getHeaders());
        return axios.get(BASE_URL + url, { headers: getHeaders() , params:  { search: searchString } });
    }

    getAvailableRoles() {
        let url = "/user/available_roles";
        return axios.get(BASE_URL + url, { headers: getHeaders() });
    }

    assignRole(username, role, unitId){
        let url = "/user/"+ username + "/assign_role";
        // console.log("getHeaders:")
        // console.log(getHeaders());
        return axios.post(BASE_URL + url,{ role: role, unit: { id: unitId} } , { headers: getHeaders() } );
    }

    deleteRole(username, role, unitId){
        let url = "/user/"+ username + "/remove_role";
        let data ={ role: role, unit: { id: unitId} };
        return axios.delete(BASE_URL + url, { headers: getHeaders()  , data: data});
    }


    getAccessibleUnits(username=null, active=false, unitId=null, permission=null) {
        if (null == username) username = store.state.auth.username;
        let url = "/user/" + username + "/permissions";
        let params = { active: active, unitId: unitId, permission: permission };
        return axios.get(BASE_URL + url, { headers: getHeaders(), params: params });
    }

    guessRoleUnit(username=null) {
        if (null == username) username = store.state.auth.username;
        let url = "/user/" + username + "/roles/guess";

        return axios.get(BASE_URL + url, { headers: getHeaders() });
    }

    // Members Services

    getCurrentCensusPeriod() {
        let url = `/census/period/current`;

        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders() } );
    }

    getLicensesProposalsByCriteria( unitId = null) {
        // Getting Licenses Proposals
        let url = "/license/proposal";
        let params = { statuses: ['PENDING'] , unitId: unitId , includeSubs: true, proposalType: null}
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders() , params:  params , paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})})
    }

    getActiveMembersReport(unitId, censusYear) {
        let url = `/report/active_members`;
        let params = {unitId: unitId, censusYear: censusYear, includeSubs: false}
        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders(), params:  params } );
    }

    getLicensesLimits(unitId) {
        let url = `/unit/${unitId}/licenses/limits`;

        return axios.get(MEMBERS_BASE_URL + url, {headers: getHeaders() });
    }

    // Training Services

    getActivitiesByCriteria(params) {
        let url = "/info/activity";
        return axios.get(TRAINING_BASE_URL + url, { headers: getHeaders() , params: params , paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})})

    }

    getApplyActivitiesByTrainer(memberId) {
        let url = `/apply-activity/trainer/${memberId}`;
        return axios.get(TRAINING_BASE_URL + url, {headers: getHeaders() });
    }

    getApplyActivitiesByTrainee(memberId) {
        let url = `/apply-activity`;
        let params = {memberId: memberId, status: 'IN_PROGRESS'};

        return axios.get(TRAINING_BASE_URL + url, {headers: getHeaders(), params:params });
    }


    // Excursions Services

    getAttendanceReport(fromDate, toDate, unitId, branch, orderBy) {
        let url = `/report/attendance`;
        let params = {fromDate: fromDate, toDate: toDate, unitId: unitId, branch: branch, orderBy: orderBy};
        return axios.get(EXCURSIONS_BASE_URL + url, {headers: getHeaders(), params:params } );
    }

    getExcursionsByCriteria(unitId) {
        let url = "/excursion";
        let criteria = {status: 'SUBMITTED', paged: false, pageSize: null, pageNumber: null, type: null, statuses: null, types: null, unitId: unitId}
        return axios.get(EXCURSIONS_BASE_URL + url, { headers: getHeaders(), params: criteria,  paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'}) });
    }

    // Achievement Services

    getEvalCriteriaProgress(unitId, versionId, successLimit) {
        let url = `/unit/${unitId}/eval_criteria/${versionId}`;

        return axios.get(ACHIEVEMENT_BASE_URL + url, {headers: getHeaders(), params:{successLimit: successLimit} });
    }

    getAchievementProgress(unitId,versionId,types) {
        let url = `/unit/${unitId}/achievements/${versionId}`;

        return axios.get(ACHIEVEMENT_BASE_URL + url, {headers: getHeaders(), params:{types: types}, paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'}) });
    }

    getRequirementVersion() {
        let url = `/requirement_version`;

        return axios.get(ACHIEVEMENT_BASE_URL + url, {headers: getHeaders(), params:{active: true} });
    }

    enableUser(username, enable) {
            let url = "/user/"+ username + "/activate";
            return axios.put(BASE_URL + url,{ enabled: enable } , { headers: getHeaders() } );
    }

    verifyUser(username, verify) {
        let url = "/user/"+ username + "/verify";
        return axios.put(BASE_URL + url,{ verified: verify } , { headers: getHeaders() } );
    }
    truncateRoles(username) {
        let url = "/user/"+ username + "/truncate_roles";
        return axios.delete(BASE_URL + url, { headers: getHeaders() } );
    }
}

export default new EsepService();